import React from 'react';
import Image from '../../../../Shared/Image/image';
import './internetOrderError.scss';

const TITLE = 'אנחנו בודקים עוד כמה דברים וחוזרים אלייך';
const SUBTITLE = 'נציגינו יחזרו אליך בהקדם האפשרי כדי לסיים את התהליך';
const BUTTON_TEXT = 'הבנתי, תודה';

const InternetOrderError = ({ onClose }) => (
  <div className='internet-order-error'>
    <Image
      src={require('./images/fail.svg')}
      className='internet-order-error__icon'
      alt=''
    />
    <h1 className='internet-order-error__title'>{TITLE}</h1>
    <p className='internet-order-error__subtitle'>{SUBTITLE}</p>
    <button type='button' className='internet-order-error__button' onClick={onClose}>
      {BUTTON_TEXT}
    </button>
  </div>
);

export default InternetOrderError;
